import { MainState } from './main-reducer';
import { MAIN_ACTION_TYPE, MainActions, SetMainLoadingAction } from './main-type';

export const mainCreators = {
  setMainState: <KeyName extends keyof MainState>(key: KeyName, value: MainState[KeyName])
    : MainActions => ({
      type: MAIN_ACTION_TYPE.SET_MAIN_STATE,
      payload: { key, value }
    }),
  getMasterData: (): MainActions => ({
    type: MAIN_ACTION_TYPE.GET_MASTER_DATA,
  }),
  callMasterDataAndLandingStatus: () => ({
    type: MAIN_ACTION_TYPE.CALL_MASTER_DATA_AND_LANDING_STATUS,
  }),
  postConfirmAllChange: () => ({
    type: MAIN_ACTION_TYPE.POST_CONFIRM_ALL_CHANGE,
  }),
  callPreload: () => ({
    type: MAIN_ACTION_TYPE.CALL_PRELOAD,
  }),
  setMainLoading: (key: string, value: boolean): SetMainLoadingAction => ({
    type: MAIN_ACTION_TYPE.SET_MAIN_LOADING,
    payload: { key, value }
  })
};
